module.exports = __webpack_public_path__ + "img/link_icon_small.01584883.svg";